<div class="all-customers" *ngIf="!cms && !shopifyDownload && !nonShopifyDownload; else notcondition">
  <!-- <div *ngIf="account && account.id" class="new-theme">
    <pv-top-toolbar *ngIf="!splash" [loggedIn]="loggedIn" (onToggleSnav)="snav.toggle()"></pv-top-toolbar>
    <mat-sidenav-container class="sidenav-container" [ngClass]="{ alerts: hasAlert, splash: splash }">
        <mat-sidenav #snav mode="over" [(opened)]="opened" class="sidenav app-linkbar">
            <div class="link accent-background hover-light-accent-background home-button">
                <a [routerLink]="['/']" (click)="snav.close()">
                    Home
                </a>
            </div>

            <div *ngFor="let route of toolbarDTO" routerLinkActive="app-active">
                <div *ngIf="route.link" class="link accent-background hover-light-accent-background home-button">
                    <a [href]="route.link" target="_blank">
                        {{ route.header }}
                    </a>
                </div>

                <div *ngIf="route.route" class="link accent-background hover-light-accent-background" routerLinkActive="lightest-primary-background" [routerLinkActiveOptions]="{exact: true}">
                    <a [routerLink]="route.route" (click)="route.toolbarColumns && !route.toolbarColumns.length && snav.close()">
                        {{ route.header }}
                    </a>
                </div>

                <div *ngFor="let toolbarColumn of route.toolbarColumns">
                    <div *ngFor="let child of toolbarColumn" class="child-link hover-lightest-accent-background" routerLinkActive="light-primary-background" [routerLinkActiveOptions]="{exact: true}">
                        <a *ngIf="child.route" [routerLink]="child.route" (click)="snav.close()">
                            {{ child.label }}
                        </a>
                        <a *ngIf="!child.route && child.link" [href]="child.link" target="_blank" (click)="snav.close()">
                            {{ child.label }}
                        </a>
                    </div>
                </div>


                <div class="child-store" *ngIf="route.module == 'store' && route.storeToolbar && route.storeToolbar.columns">
                    <div *ngFor="let col of route.storeToolbar.columns">
                        <div class="child-header">
                            {{ col.label }}
                        </div>
                        <div *ngFor="let item of col.items" class="child-link hover-light-primary-background">
                            <a [routerLink]="['/store', item.url_alias]" (click)="snav.close()" class="primary-to-accent">
                                {{ item.label }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </mat-sidenav>

        <mat-sidenav #cnav position="end">
            <pv-sidenav-popup (onClose)="cnav.close()" [cartItem]="sidenavCartItem" [crossSell]="sidenavCrossSell"></pv-sidenav-popup>
        </mat-sidenav>

        <mat-sidenav-content class="sidenav-content">
            <div class="loader-container" id="loader-scroll">
                <pv-loader class='loader'></pv-loader>
            </div>
            <div class="outlet-container" [ngClass]="{ home: isHome, outletsplash: splash }">
                <router-outlet (activate)="onActivate($event)" (deactivate)="onActivate($event)" #outlet></router-outlet>
            </div>
            <div class="footer" *ngIf="!splash">
                <pv-footer></pv-footer>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
  </div> -->
</div>

<!-- ### #1111 SPINNER ADDED ### -->
<div class="loader-spinner-overlay">
    <pv-loader-spinner></pv-loader-spinner>
</div>

<ng-template #notcondition>
  <div *ngIf="cms && account; else isshopify" class="new-theme">
      <pv-cms-toolbar></pv-cms-toolbar>
  </div>
</ng-template>

<ng-template #isshopify>
    <div *ngIf="shopifyDownload && !nonShopifyDownload; else isdownload">


        <div style="background-color: black; height: 70px; width: 100%;">
            <div class="container">
                <span class="centered">
                    <a href="http://polyvinylrecords.com/">
                        <img height="50" src="https://polyvinyl-public.s3.amazonaws.com/da7cb1c7a56e5508fadea4e8870564c45d271488_5b37a3b66841194f72b00ef2db40f8694ca9b44b_thumb_png"/>
                    </a>
                </span>
                <span class="right-justified" style="color: white;">
                    <a href="http://polyvinylrecords.com/" style="color: white;">Polyvinyl Records Main Site ➜</a>
                </span>
            </div>
        </div>


        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav-content style="overflow-x: hidden;">
                <div class="outlet-container">
                    <router-outlet>
                        <pv-order-download-shopify></pv-order-download-shopify>
                    </router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</ng-template>

<ng-template #isdownload>
    <div *ngIf="nonShopifyDownload;">


        <div style="background-color: black; height: 70px; width: 100%;">
            <div class="container">
                <span class="centered">
                    <a href="http://polyvinylrecords.com/">
                        <img height="50" src="https://polyvinyl-public.s3.amazonaws.com/da7cb1c7a56e5508fadea4e8870564c45d271488_5b37a3b66841194f72b00ef2db40f8694ca9b44b_thumb_png"/>
                    </a>
                </span>
                <span class="right-justified" style="color: white;">
                    <a href="http://polyvinylrecords.com/" style="color: white;">Polyvinyl Records Main Site ➜</a>
                </span>
            </div>
        </div>


        <mat-sidenav-container class="sidenav-container">
            <mat-sidenav-content style="overflow-x: hidden;">
                <div class="outlet-container">
                    <router-outlet>
                        <pv-iheartvinyl></pv-iheartvinyl>
                    </router-outlet>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>
</ng-template>